import React from 'react'
import Page from 'src/components/Page'
import {
  makeStyles,
  Grid,
  Typography,
  Button,
} from '@material-ui/core'
import {
  Route,
  Routes,
  Link,
  useLocation,
} from 'react-router-dom'
import { ArrowLeft, User } from 'react-feather'
import RefereeGroups from './RefereeGroups'
import GroupForm from './GroupForm'

const useStyle = makeStyles(() => ({
  root: {
    padding: 10,
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
}))

const Referee = () => {
  const classes = useStyle()
  const { pathname } = useLocation()

  return (
    <Page
      className={classes.root}
      title={pathname === '/app/referee' ? 'مدیریت گروه های داوری' : 'مدیریت گروه های کاربری'}
    >
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>
          <Typography variant="h3" component="h3">{pathname === '/app/referee' ? 'مدیریت گروه های داوری' : 'مدیریت گروه های کاربری'}</Typography>

          {pathname === '/app/referee'
            ? (
              <Link to="./add">
                <Button variant="contained" color="primary">
                  <User size={16} className={classes.icon} />
                  ایجاد گروه جدید
                </Button>
              </Link>
            )
            : (
              <Link to="../referee">
                <Button>
                  بازگشت
                  <ArrowLeft />
                </Button>
              </Link>
            )}
        </Grid>

        <Routes>
          <Route path="/" element={<RefereeGroups />} />
          <Route path="/add" element={<GroupForm />} />
          {/* <Route path="/edit/:groupId/:ageId/:groupName" element={<GroupForm />} /> */}
          <Route path="/edit/:groupId" element={<GroupForm />} />
        </Routes>
      </Grid>
    </Page>

  )
}

export default Referee
